import { useIsMobile } from '@ori/presentation-hooks';
import useTestId from '@ori/testid-generator';
import { Skeleton } from '@ori-ui/mui';
import { INTRO_TEXT_SKELETON } from "./constants";
import { Root } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders Skeleton for `IntroText`.
 */
export var IntroTextSkeleton = function IntroTextSkeleton(_ref) {
  var _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'pulse' : _ref$animation,
    className = _ref.className;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(Root, {
    className: className,
    "data-testid": getTestId(INTRO_TEXT_SKELETON),
    children: /*#__PURE__*/_jsx(Skeleton, {
      variant: "rectangular",
      width: "100%",
      height: isMobile ? '132px' : '88px',
      animation: animation
    })
  });
};
//# sourceMappingURL=IntroTextSkeleton.js.map